import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../atoms/Image';
import FishermanLogoWhite from './fisherman-logo.svg';
import './FishermanBanner.css';

export default function FishermanBanner(props) {
  const { backgroundColor } = props;

  return (
    <div className="fisherman-banner" style={{ backgroundColor }}>
      <a href="https://gofisherman.com/" target="_blank" rel="noopener">
        <span>Powered by</span>
        <Image className="fisherman-logo" src={FishermanLogoWhite} />
      </a>
    </div>
  );
}

FishermanBanner.propTypes = {
  backgroundColor: PropTypes.string,
};

FishermanBanner.defaultProps = {
  backgroundColor: 'black',
};
